// BANKS — procedures vs entries per bank, as the run probed them.

import type { BankStats } from '../../services/kbEffectiveness';
import styles from '../KBEffectivenessPage.module.css';

interface Props {
  banks: BankStats[];
}

export function BanksTable({ banks }: Props) {
  if (banks.length === 0) return null;
  return (
    <section className={styles.panel} aria-label="Banks">
      <div className={styles.panelHead}>
        <h2>Banks — procedures vs entries</h2>
        <span className={styles.meta}>as probed by this run</span>
      </div>
      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>bank</th>
              <th>kind</th>
              <th>mount</th>
              <th className={styles.num}>playbooks</th>
              <th className={styles.num}>entries</th>
              <th>note</th>
            </tr>
          </thead>
          <tbody>
            {banks.map((b) => (
              <tr key={b.key}>
                <td>{b.label}</td>
                <td>{b.kind}</td>
                <td><code className={styles.profileTag}>{b.mount}</code></td>
                <td className={styles.num}>{b.playbook_count ?? '?'}</td>
                <td className={styles.num}>{b.entry_count ?? '?'}</td>
                <td className={styles.note}>{b.error ?? ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
